import { createAppAsyncThunk } from "@/store/createAppAsyncThunk";
import { fetchMessagesByTicketIdAsync } from "./messageListApi";
import type { AppDispatch } from "@/store/store";
import { addMessageRequest } from "../../ticketApi";
import { addMessage } from "../../ticketMessages/ticketMessagesReducer";

export const fetchMessagesByTicketIdThunk = createAppAsyncThunk(
  "ticket/messages/fetch",
  async (id: string) => {
    const response = await fetchMessagesByTicketIdAsync(id);
    return response.data;
  },
);

export const addNewMessageThunk = ({
  id,
  content,
  attachments,
}: AddMessageParams) => {
  return async (dispatch: AppDispatch) => {
    const response = await addMessageRequest(id, content, attachments);
    dispatch(addMessage(response.data));
    return response;
  };
};

export interface AddMessageParams {
  id: number;
  content: string;
  attachments?: File[];
}

// Derive TicketMessage type from API response
type MessagesResponse = Awaited<
  ReturnType<typeof fetchMessagesByTicketIdAsync>
>;
type MessagesArray = MessagesResponse["data"];
export type TicketMessage = NonNullable<MessagesArray>[number];
export type Attachment = NonNullable<TicketMessage["attachments"]>[number];
